const { cELM, getAnswerVariableCssClass, getQuestionTestId } = require("../../utils.js");
const Provider = require("./provider.js");
const Option = require("./option.js");
const Question = require("./question.js");

class Component {
  constructor(params) {
    this._params = params;
    this._data = params.data;
    const cssVariableKey = getAnswerVariableCssClass(this._data);
    this._element = cELM("div", `component-block ${cssVariableKey}`);
    this._option = null;

    this.createElement();
  }

  createElement() {
    if (this._data.format === "empty") return;

    const p = new Provider(this._params);
    const m = new Question(this._params);
    this._option = new Option(this._params);

    const value = this._data;

    const testId = getQuestionTestId(value);
    testId && this._element.setAttribute('data-testid', testId);
    value.status && this._element.classList.add(value.status);
    value.format && this._element.classList.add(value.format);

    if (
      value.format === "welcome/language" ||
      value.format === "singleselect-object" ||
      value.format === "singleselect-insurance" ||
      value.format === "singleselect-other" ||
      value.format === "singleselect" || // AR: convert all single select to single select flex for now
      value.format === "phq" ||
      value.format === "info-card-v2" ||
      value.format === "schedule-time" ||
      value.format === "schedule-date" ||
      value.format === "reason-of-visit" ||
      value.format === "department-select" ||
      value.format === "provider-select" ||
      value.format === "reason-of-visit-v2" ||
      value.format === "department-select-v2" ||
      value.format === "provider-select-v2" ||
      (value.format === "array" && value.values && value.values.indexOf("|") > -1)
    ) {
      this._element.classList.remove("singleselect");
      this._element.classList.remove("singleselect-insurance");
      if (value.format === "singleselect-other") {
        if (value.values) {
          this._element.classList.add("singleselectflex");
        }
      } else {
        this._element.classList.add("singleselectflex");
      }
    } else if (value.format === "ppl-height") {
      this._element.classList.add("height");
    } else if(value.format === 'multiselect-v2' || value.format === 'multiselect-object') {
      this._element.classList.add('multiselect');
    }

    if (this._data.format) {
      this._element.addELM(p);
    }

    if (value.format === "info-card" || value.format === "info-card-v2") {
      //AR info card has 2 block
      let m1;
      if ((this._params.data || {}).questionSubtext) {
        m1 = new Question({ data: { text: this._params.data.text, subtext: this._params.data.questionSubtext } }, "info-card-instruction");
      } else {
        m1 = new Question({ data: { text: this._params.data.text } }, "info-card-instruction");
      }
      this._element.addELM(m1);
      const m2 = new Question(
        { data: { subtext: this._params.data.subtext } },
        "info-card-content",
      );
      this._element.addELM(m2);
    } else if (this._data.status === "typing" || this._data.text || this._data.subtext) {
      this._element.addELM(m);
    }

    if (this._data.image) {
      const img = cELM("img", "image-area");
      img.style.display = "block";
      img.style.margin = "0 auto";
      img.style.maxWidth = "700px";
      img.style.maxHeight = "700px";
      img.src = this._data.image;
      this._element.addELM(img);
    }

    if (this._option.getHTML() && value.status !== "typing") {
      this._element.addELM(this._option);
    }
  }

  getELM() {
    return this._element;
  }

  getHTML() {
    return this._element;
  }

  updateAnswer(value, callback) {
    this._option.updateAnswer(value, this._element, callback);
  }

  focus() {
    this._option.focus();
  }
}

module.exports = Component;
